import { useEffect, useState } from "react";
import { AppDialog } from "../../../../../common/components/AppDialog/AppDialog";
import { DefaultButton } from "../../../../../common/components/button/defaultButton/DefaultButton";
import { SelectField } from "../../../../../common/components/forms/inputs/dropdown/SelectField";
import { useAppContext } from "../../../../../AppContext";
import { IStudioQrCode } from "./models/studioQrCodeModels";
import styles from "./StudioQrCodesSection.module.scss";

interface ITransferQrCodeDialogProps {
  visible: boolean;
  onHide: () => void;
  qrCode: IStudioQrCode | null;
  currentStudioId: number;
  isTransferring: boolean;
  onTransfer: (targetStudioId: number) => void;
}

export const TransferQrCodeDialog = ({
  visible,
  onHide,
  qrCode,
  currentStudioId,
  isTransferring,
  onTransfer,
}: ITransferQrCodeDialogProps) => {
  const { userStudios, isDesktopOrTablet } = useAppContext();

  const [selectedStudioId, setSelectedStudioId] = useState<number | null>(
    null,
  );

  // The code already belongs to the current studio — it makes no sense to offer it as a
  // transfer target, so it is left out of the list rather than shown disabled.
  const targetStudios = userStudios.filter(
    (studio) => studio.id !== currentStudioId,
  );

  useEffect(() => {
    if (visible) {
      setSelectedStudioId(null);
    }
  }, [visible, qrCode]);

  const handleTransfer = () => {
    if (selectedStudioId) {
      onTransfer(selectedStudioId);
    }
  };

  return (
    <AppDialog
      visible={visible}
      onHide={onHide}
      header="Прехвърляне на QR код"
      tooltip="Прехвърля QR кода към друг ваш обект. Отпечатаният код и адресът, който сканира, остават същите — само собствеността му се сменя."
      style={{ width: isDesktopOrTablet ? "450px" : "90vw" }}
    >
      <div className={styles.dialog_form}>
        {qrCode && (
          <p className={styles.empty}>
            Изберете обекта, на който ще принадлежи занапред „{qrCode.name}
            “.
          </p>
        )}

        {targetStudios.length === 0 ? (
          <p className={styles.empty}>
            Нямате друг обект, към който да прехвърлите този QR код.
          </p>
        ) : (
          <SelectField
            label="Нов обект"
            width="100%"
            options={targetStudios}
            value={selectedStudioId ?? undefined}
            onChange={setSelectedStudioId}
            includeId={false}
            required
          />
        )}

        <div className={styles.dialog_actions}>
          <DefaultButton
            label="Отказ"
            design="link"
            type="button"
            width="auto"
            onClick={onHide}
          />
          <DefaultButton
            label="Прехвърли"
            type="button"
            width="auto"
            loading={isTransferring}
            disabled={!selectedStudioId}
            onClick={handleTransfer}
          />
        </div>
      </div>
    </AppDialog>
  );
};
